import type { ComparisonFeature } from './search-novelty-result-api.ts';

export interface NoveltyFeatureComparisonRequest {
    task_id: string;
    patent_pns: string[];
    operate_type?: string;
    text?: string;
    /**是否新增专利 */
    is_add_patent?: boolean;
    /**新增专利是否默认选中进入文献确认 */
    add_patent_selected?: boolean;
}

export interface NoveltyFeatureComparisonResponse {
    final_res: {
        patent_id: string;
        features: ComparisonFeature[];
        public_score: number;
        document: string;
        lang: string;
        comparativeLiteratureType?: 'X' | 'Y' | 'A';
    }[];
    threshold: number;
}

export interface NoveltyFeatureComparisonApi {
    /**
     * 获取技术特征对比得分
     * @param data
     * @returns
     */
    getFeatureComparison: (data: NoveltyFeatureComparisonRequest) => Promise<NoveltyFeatureComparisonResponse>;
}

export const NoveltyFeatureComparisonApi = Symbol('NoveltyFeatureComparisonApi');
